import classNames from 'classnames';
import styles from './BlockContainer.module.scss';

const BlockFooter = ({ children, className, style, addBorder, ...props }) => {
  return (
    <div {...props} className={classNames(styles['block-container__footer'], { [styles['border']]: addBorder }, className)} style={style}>
      {children}
    </div>
  );
};
export { BlockFooter as default, BlockFooter };
